/* Author: Sabastian Bradley */

(() => {
  const STATUS = {
    in_stock_showroom: { cls: "k-badge--showroom", text: () => "In Stock | Showroom" },
    in_stock: { cls: "k-badge--instock", text: () => "In Stock" },
    limited_quantity: { cls: "k-badge--limited", text: (qty) => `LIMITED | ${qty} Left` },
    no_stock: { cls: "k-badge--nostock", text: () => "No Stock | Need to Order" },
  };

  function apply(el, statusKey, qty = 0) {
    const config = STATUS[statusKey];
    if (!config) return;
    el.textContent = config.text(qty);
    el.classList.remove("k-badge--showroom", "k-badge--instock", "k-badge--limited", "k-badge--nostock");
    el.classList.add(config.cls);
  }

  function statusFromEntry(entry) {
    if (!entry) return { status: "no_stock", qty: 0 };

    const qty = Number(entry.qty || 0);
    const mode = String(entry.mode || "").toLowerCase().trim();

    if (mode === "showroom" || mode === "in_stock_showroom") {
      return { status: "in_stock_showroom", qty };
    }

    if (mode === "in_stock") {
      return { status: "in_stock", qty };
    }

    if (mode === "limited_quantity") {
      return { status: "limited_quantity", qty };
    }

    if (mode === "need_to_order" || mode === "special_order" || mode === "no_stock") {
      return { status: "no_stock", qty: 0 };
    }

    return { status: "no_stock", qty: 0 };
  }

  function getVariantIdFromURL() {
    try {
      return new URLSearchParams(window.location.search).get("variant");
    } catch {
      return null;
    }
  }

  function findIdEl(root) {
    return (
      root.querySelector('#add-to-cart-form [name="id"]') ||
      root.querySelector('form[action^="/cart/add"] [name="id"]') ||
      null
    );
  }

  function initWrap(wrap) {
    const badgeEl = wrap.querySelector("[data-k-stock-badge]");
    const mapScript = wrap.querySelector("[data-k-stock-map]");
    if (!badgeEl || !mapScript) return;

    let map = {};
    try { map = JSON.parse(mapScript.textContent || "{}"); } catch {}

    const root = wrap.closest("#product-box") || wrap.closest("section") || document;
    let idEl = findIdEl(root) || findIdEl(document);
    let lastId = null;

    const update = () => {
      if (!idEl) idEl = findIdEl(root) || findIdEl(document);

      const id = getVariantIdFromURL() || idEl?.value || null;
      if (!id || id === lastId) return;
      lastId = id;

      const entry = map[String(id)];
      const result = statusFromEntry(entry);
      apply(badgeEl, result.status, result.qty);
    };

    update();
    root.addEventListener("change", update, true);
    window.addEventListener("popstate", update);

    if (!window.__kStockHistoryPatched) {
      window.__kStockHistoryPatched = true;

      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      history.pushState = function () {
        originalPushState.apply(this, arguments);
        window.dispatchEvent(new Event("k:historychange"));
      };

      history.replaceState = function () {
        originalReplaceState.apply(this, arguments);
        window.dispatchEvent(new Event("k:historychange"));
      };
    }

    window.addEventListener("k:historychange", update);
    setInterval(update, 200);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-k-stock-wrap]").forEach(initWrap);
  });
})();